import React from 'react';
import s from '../CreateInvoice.module.css';
import style from '../CreateInvoice.module.css';
import Select, {SingleValue} from 'react-select';
import {useTranslation} from 'react-i18next';
import {useFormikContext} from 'formik';
import {CreateInvoiceType, OrderTypeValueType} from '../../../types/TypesStore';
import CustomSelect from '../../../Components/Select/CustomSelect';

type OptionType = {
	label: string;
	value: string;
};
type Props = {
	setOrderType: (value: OrderTypeValueType | string) => void;
};
const InvoiceTypeSelect: React.FC<Props> = ({setOrderType}) => {
	const {t} = useTranslation();
	const {values, setFieldValue, errors, touched} = useFormikContext<CreateInvoiceType>();
	const options: OptionType[] = [
		{label: t('Замовлення'), value: 'income'},
		{label: t('Повернення'), value: 'outcome'},
		/*{label: t('Предзамовлення'), value: 'pre-order'},*/
		{label: t('Списання'), value: 'write-off'},
		/*{label: t('Order?'), value: 'order'},*/
	];
	const defaultValue: OptionType | undefined = options.find(
		(o) => o.value === values.type,
	);

	const handleChangeType = (newValue: SingleValue<OptionType>) => {
		if (newValue) {
			setFieldValue('type', newValue.value);
			setOrderType(newValue.value);
		}
	};
	return (
		<div className={s.typeInvoiceSelect}>
			<div className={style.typeInvoiceSelectLeft}>
				<span>{t('Тип накладної')}</span>
				<CustomSelect
					onChange={handleChangeType}
					options={options}
					value={defaultValue} //{label: 'Замовлення', value: 'income'}}
					className={s.typeInvoiceSelect_Select}
					components={{
						IndicatorSeparator: () => null,
					}}
				/>
				{errors.type && touched.type && (
					<div className={s.errorMessage}>{errors.type}</div>
				)}
				{/*<Select
					onChange={handleChangeType}
					options={options}
					value={defaultValue} //{label: 'Замовлення', value: 'income'}}
					className={s.typeInvoiceSelect_Select}
					components={{
						IndicatorSeparator: () => null,
					}}
				/>*/}
			</div>
		</div>
	);
};

export default InvoiceTypeSelect;
